import * as AvatarPrimitive from "@radix-ui/react-avatar";
import styled from "styled-components";

export interface FallbackProps {
  $backgroundColor: string;
}

export const Fallback = styled(AvatarPrimitive.Fallback)<FallbackProps>`
  width: 100%;
  min-width: 24px;
  height: 100%;
  font-family: "Open Sans";
  object-fit: cover;
  background: ${({ $backgroundColor }) => $backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  color: var(--mode-text-default-color);
`;

export default Fallback;
